/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
interface Props extends Omit<React.SVGProps<SVGSVGElement>, "css"> {
  weight?: "thin" | "normal";
}
export const IconError = React.forwardRef<SVGSVGElement, Props>(
  (
    { fill = "none", stroke = "currentColor", weight = "normal", ...props },
    ref,
  ) => (
    <svg
      fill={fill}
      viewBox="0 0 26 26"
      ref={ref}
      css={css`
        * {
          vector-effect: non-scaling-stroke;
        }
        overflow: visible;
        height: 26px;
      `}
      {...props}
    >
      <path
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={weight === "normal" ? 1.5 : 1}
        d="M13 1c6.628 0 12 5.372 12 12s-5.372 12-12 12S1 19.628 1 13 6.372 1 13 1z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M9.613 8.21a1 1 0 0 0-1.32 1.497L11.586 13l-3.293 3.293-.083.094a1 1 0 0 0 1.497 1.32L13 14.414l3.293 3.293.094.083a1 1 0 0 0 1.32-1.497L14.414 13l3.293-3.293.083-.094a1 1 0 0 0-1.497-1.32L13 11.586 9.707 8.293l-.094-.083z"
        clipRule="evenodd"
      />
    </svg>
  ),
);
